import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "これから確定する会議時間の前後にバッファを設定することが出来ます。", -1)
const _hoisted_3 = { class: "w100 fl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "mt20"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, "場所（場所情報が未入力のイベントで、デフォルトの場所として補完します）", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fl fs20 fw600 ml10 mr10 mt10" }, "+", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "fl fs14 mt20" }, "分", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl fs14 fw600 ml5 mr5",
  style: {"line-height":"50px"}
}, "固定時間: ", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "fl mr20" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl ml5",
  style: {"line-height":"50px"}
}, "前後", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl ml5 mr20",
  style: {"line-height":"50px","margin-left":"5px"}
}, "分", -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "fl mr20" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl ml5",
  style: {"line-height":"50px"}
}, "前", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl ml5 mr20",
  style: {"line-height":"50px","margin-left":"5px"}
}, "分", -1)
const _hoisted_24 = { class: "fl" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl",
  style: {"line-height":"50px","margin-left":"5px"}
}, "後", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl",
  style: {"line-height":"50px","margin-left":"5px"}
}, "分", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { class: "fl mt30" }
const _hoisted_30 = { class: "ml5 fl mr20" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: `sync_travel_time_event_`,
  class: "fs13 pointer"
}, " 確定時にバッファ（移動時間）もイベントとして作成", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "fl"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = { class: "fl mt30" }
const _hoisted_38 = { class: "ml5 fl mr20" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: `use_location_converter_`,
  class: "fs13 pointer"
}, " 場所コンバーターを利用", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "fl"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, "イベントの場所に設定されている名称を特定の住所に変換し、移動時間を考慮します。（上から優先順）", -1)
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "w100 borderGrey rad4 hoverLgreyBg" }
const _hoisted_45 = ["src"]
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "padw10 fl" }
const _hoisted_48 = {
  key: 0,
  class: "fs12 grey"
}
const _hoisted_49 = ["src", "onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  class: "grey",
  style: {"margin-top":"50px"}
}
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = ["src"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600" }, "場所コンバーターを追加", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_openBlock(), _createElementBlock("section", {
    style: {},
    class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
  }, [
    _createElementVNode("p", {
      class: "header_title fs24",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickMeetingBufferContent && _ctx.clickMeetingBufferContent(...args)))
    }, "移動時間考慮"),
    (_ctx.openMeetingBufferContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_component_SelectTag, {
                name: "travel_time_mode",
                id: "select_travel_time_mode",
                class: "fl fs14 roundForm w100",
                style: {"min-width":"280px","height":"50px"},
                options: _ctx.AvailableScheduleTag.travelTimeModeOptions().map(e => e.text),
                defaultOption: _ctx.defaultModeOption,
                onSelectValue: _ctx.selectTravelMode
              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
              _hoisted_4,
              _hoisted_5,
              (_ctx.showLocationField())
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _hoisted_8,
                    _createVNode(_component_TextfieldTag, {
                      placeholder: "可能時間のスタートする場所を入力",
                      style: {"height":"50px","min-width":"400px"},
                      class: "fl fs14 roundForm",
                      value: _ctx.getLocation(),
                      onInputValue: _ctx.inputLocation
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_9,
                    _createVNode(_component_MdTextfieldTag, {
                      fieldStyle: "min-width:110px;max-width:110px;",
                      style: {"height":"56px","min-width":"110px","max-width":"110px","margin-top":"-10px"},
                      class: "fl fs16",
                      type: `number`,
                      name: "移動時間+α",
                      placeholder: `30`,
                      min: 0,
                      max: 999,
                      value: _ctx.rcm.room_setting.additional_fixed_travel_min,
                      onInputValue: _ctx.inputAdditionalFixedTravelMin,
                      onBlur: _ctx.blurAdditionalFixedTravelMin
                    }, null, 8, ["value", "onInputValue", "onBlur"]),
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.showBufferField())
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                (_ctx.showFixBufferField())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      (!_ctx.separateMin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createVNode(_component_SelectTag, {
                                name: "meeting_days_start",
                                id: "select_period_start_days",
                                class: "fl fs14 roundForm",
                                style: {"min-width":"30px","height":"50px"},
                                options: _ctx.Util.selectBufferMinutes,
                                defaultOption: _ctx.getFixedTravelBeforeMin(),
                                onSelectValue: _ctx.inputFixedTravelBeforeMin,
                                isDisabled: false
                              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                              _hoisted_19
                            ]),
                            _createElementVNode("span", {
                              class: "fw600 underline dblue pointer",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.separateTravelMin && _ctx.separateTravelMin(...args)))
                            }, "前後分ける")
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _createVNode(_component_SelectTag, {
                                name: "meeting_days_start",
                                id: "select_period_start_days",
                                class: "fl fs14 roundForm",
                                style: {"min-width":"30px","height":"50px"},
                                options: _ctx.Util.selectBufferMinutes,
                                defaultOption: _ctx.getFixedTravelBeforeMin(),
                                onSelectValue: _ctx.inputFixedTravelBeforeMin,
                                isDisabled: false
                              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                              _hoisted_23
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createVNode(_component_SelectTag, {
                                name: "meeting_days_start",
                                id: "select_period_start_days",
                                class: "fl fs14 roundForm",
                                style: {"min-width":"30px","height":"50px"},
                                options: _ctx.Util.selectBufferMinutes,
                                defaultOption: _ctx.getFixedTravelAfterMin(),
                                onSelectValue: _ctx.inputFixedTravelAfterMin,
                                isDisabled: false
                              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                              _hoisted_26
                            ]),
                            _hoisted_27
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_CheckboxTag, {
                      value: ``,
                      name: `sync_travel_time_event`,
                      checked: _ctx.rcm.room_setting.can_sync_travel_time_to_calendar_event,
                      prefix: `sync_travel_time_event`,
                      onClickCheckbox: _ctx.clickRegisterCalTravelTime
                    }, null, 8, ["checked", "onClickCheckbox"]),
                    _createTextVNode("   "),
                    _hoisted_31,
                    _hoisted_32
                  ]),
                  (_ctx.rcm.room_setting.can_sync_travel_time_to_calendar_event)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(_component_MdTextfieldTag, {
                          fieldStyle: "min-width:180px;max-width:40%;",
                          style: {"height":"56px","min-width":"180px","max-width":"100%","margin-top":"-25px"},
                          class: "fl fs16",
                          type: `buffer`,
                          placeholder: `準備/移動時間`,
                          name: `バッファイベント名`,
                          value: _ctx.rcm.room_setting.sync_travel_time_event_name,
                          onInputValue: _ctx.inputTravelEventName,
                          onBlur: _ctx.blurTravelEventName
                        }, null, 8, ["value", "onInputValue", "onBlur"]),
                        _hoisted_34
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_35
                ]),
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_CheckboxTag, {
                      value: ``,
                      name: `use_location_converter`,
                      checked: _ctx.useLocationConverters,
                      prefix: `use_location_converter`,
                      onClickCheckbox: _ctx.clickUseLocationConverter
                    }, null, 8, ["checked", "onClickCheckbox"]),
                    _createTextVNode("   "),
                    _hoisted_39,
                    _hoisted_40
                  ]),
                  (_ctx.useLocationConverters)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _hoisted_42,
                        (_ctx.convs)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.convs, (conv, convindex) => {
                                return (_openBlock(), _createElementBlock("div", { key: convindex }, [
                                  _createElementVNode("div", _hoisted_44, [
                                    (conv.convert_type == `default`)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _ctx.$getAssetImageUrl(`/assets/call/call_mappin_red.png`),
                                          height: "60",
                                          width: "60",
                                          class: "fl"
                                        }, null, 8, _hoisted_45))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: _ctx.$getAssetImageUrl(`/assets/call/call_mappin.png`),
                                          height: "60",
                                          width: "60",
                                          class: "fl"
                                        }, null, 8, _hoisted_46)),
                                    _createElementVNode("div", _hoisted_47, [
                                      _createElementVNode("p", {
                                        class: _normalizeClass(`fs14 fw600 ${conv.convert_type == `default` ? `` : `mt10`}`)
                                      }, _toDisplayString(conv.before_keyword) + " ⇒ " + _toDisplayString(conv.convert_type == `default` ? conv.after_keyword : `この場所を利用しません`), 3),
                                      (conv.convert_type == `default`)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(conv.lat) + ", " + _toDisplayString(conv.lon), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                      width: "20",
                                      height: "23",
                                      class: "pointer fr mr15 mt20",
                                      onClick: ($event: any) => (_ctx.removeConv(conv))
                                    }, null, 8, _hoisted_49),
                                    _hoisted_50
                                  ]),
                                  _hoisted_51
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createTextVNode(" 場所コンバーターが設定されていません。 "),
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                  width: "24",
                                  height: "24",
                                  style: {"margin-top":"-8px"}
                                }, null, 8, _hoisted_54)
                              ])
                            ])),
                        _hoisted_55,
                        _createElementVNode("div", {
                          class: "pad15 pointer centered",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addConvs && _ctx.addConvs(...args)))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/round_plus.png`),
                            width: "37",
                            height: "40"
                          }, null, 8, _hoisted_56),
                          _hoisted_57,
                          _hoisted_58
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_59
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_60
        ]))
      : _createCommentVNode("", true)
  ], 2))
}